interface SvgEl {
	d: string;
	fill?: string;
	stroke?: string;
	strokeWidth?: number;
	opacity?: number;
	strokeLinecap?: "round" | "butt" | "square";
	strokeLinejoin?: "round" | "miter" | "bevel";
}

export interface PlatformLogoData {
	viewBox: string;
	elements: SvgEl[];
}

export const platformLogos: Record<string, PlatformLogoData> = {
	KakaoTalk: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#FEE500" },
			{ d: "M24 12C17.373 12 12 16.066 12 21.09c0 3.244 2.137 6.088 5.345 7.695l-1.36 5.046c-.12.446.39.81.775.554l6.024-3.964c.4.035.804.058 1.216.058 6.627 0 12-4.066 12-9.09S30.627 12 24 12z", fill: "#3C1E1E" },
		],
	},
	Naver: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#03C75A" },
			{ d: "M27.4 24.64L20.24 15H14v18h6.6V23.36L27.76 33H34V15h-6.6v9.64z", fill: "white" },
		],
	},
	Gmail: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#EA4335" },
			{ d: "M13 14H35A2 2 0 0 1 37 16V32A2 2 0 0 1 35 34H13A2 2 0 0 1 11 32V16A2 2 0 0 1 13 14Z", fill: "white" },
			{ d: "M11 16l13 9 13-9", stroke: "#EA4335", strokeWidth: 2 },
		],
	},
	Slack: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#4A154B" },
			{ d: "M17 20H17A3 3 0 0 1 20 23V29A3 3 0 0 1 17 32H17A3 3 0 0 1 14 29V23A3 3 0 0 1 17 20Z", fill: "#E01E5A" },
			{ d: "M25 14H31A3 3 0 0 1 34 17V17A3 3 0 0 1 31 20H25A3 3 0 0 1 22 17V17A3 3 0 0 1 25 14Z", fill: "#36C5F0" },
			{ d: "M31 22H31A3 3 0 0 1 34 25V31A3 3 0 0 1 31 34H31A3 3 0 0 1 28 31V25A3 3 0 0 1 31 22Z", fill: "#2EB67D" },
			{ d: "M17 28H23A3 3 0 0 1 26 31V31A3 3 0 0 1 23 34H17A3 3 0 0 1 14 31V31A3 3 0 0 1 17 28Z", fill: "#ECB22E" },
		],
	},
	SMS: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#2196F3" },
			{ d: "M16 14H32A4 4 0 0 1 36 18V28A4 4 0 0 1 32 32H16A4 4 0 0 1 12 28V18A4 4 0 0 1 16 14Z", fill: "white" },
			{ d: "M12 18l12 7 12-7", stroke: "#2196F3", strokeWidth: 1.5 },
			{ d: "M19 22.5A1.5 1.5 0 1 1 19 25.5A1.5 1.5 0 1 1 19 22.5Z", fill: "#2196F3" },
			{ d: "M24 22.5A1.5 1.5 0 1 1 24 25.5A1.5 1.5 0 1 1 24 22.5Z", fill: "#2196F3" },
			{ d: "M29 22.5A1.5 1.5 0 1 1 29 25.5A1.5 1.5 0 1 1 29 22.5Z", fill: "#2196F3" },
		],
	},
	WhatsApp: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#25D366" },
			{ d: "M24 12a12 12 0 00-10.4 17.96L12 36l6.24-1.56A12 12 0 1024 12zm0 21.6a9.6 9.6 0 01-4.9-1.34l-.35-.21-3.63.95.97-3.54-.23-.37A9.6 9.6 0 1124 33.6z", fill: "white" },
			{ d: "M29.5 26.27c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07a8.14 8.14 0 01-2.4-1.48 9 9 0 01-1.66-2.07c-.17-.3-.02-.47.13-.62.14-.14.3-.35.45-.52s.2-.3.3-.5.05-.37-.02-.52c-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57a1.1 1.1 0 00-.8.37 3.34 3.34 0 00-1.04 2.49c0 1.47 1.07 2.89 1.22 3.09s2.1 3.22 5.1 4.51c.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.09 1.77-.72 2.02-1.42s.25-1.3.17-1.42c-.07-.13-.27-.2-.57-.35z", fill: "#25D366" },
		],
	},
	Toss: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#0064FF" },
			{ d: "M16 17h16v3H26v13h-4V20h-6v-3z", fill: "white" },
		],
	},
	Iamport: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#5B2C87" },
			{ d: "M24 14A2 2 0 1 1 24 18A2 2 0 1 1 24 14Z", fill: "white" },
			{ d: "M24 21H24A2 2 0 0 1 26 23V32A2 2 0 0 1 24 34H24A2 2 0 0 1 22 32V23A2 2 0 0 1 24 21Z", fill: "white" },
		],
	},
	Stripe: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#635BFF" },
			{ d: "M22.5 19.5c0-1.1.9-1.5 2.4-1.5 2.1 0 4.8.65 6.9 1.8V13.6c-2.3-.92-4.6-1.3-6.9-1.3-5.6 0-9.4 2.95-9.4 7.85 0 7.65 10.5 6.45 10.5 9.75 0 1.3-1.15 1.7-2.7 1.7-2.35 0-5.35-.95-7.7-2.25v6.3c2.6 1.12 5.25 1.6 7.7 1.6 5.75 0 9.7-2.85 9.7-7.85-.02-8.25-10.5-6.8-10.5-9.9z", fill: "white" },
		],
	},
	PayPal: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#003087" },
			{ d: "M30.5 16c-.8-1.8-2.8-2.5-5.3-2.5h-6.9c-.5 0-.9.35-1 .85l-2.85 18.1c-.05.35.2.65.55.65h4l1.05-6.65-.03.2c.1-.5.5-.85 1-.85h2.05c4.05 0 7.2-1.65 8.15-6.4.03-.14.05-.28.07-.4.28-1.85-.02-3.1-1.04-4.05z", fill: "#27346A" },
			{ d: "M31.54 20.45c-.95 4.75-4.1 6.4-8.15 6.4h-2.05c-.5 0-.9.35-1 .85l-1.35 8.55c-.04.3.18.55.48.55h3.35c.43 0 .8-.31.87-.73l.04-.18.68-4.35.05-.23c.07-.43.44-.74.87-.74h.55c3.55 0 6.33-1.44 7.14-5.62.34-1.75.16-3.2-.73-4.22a3.5 3.5 0 00-1-.52c.09.43.14.86.14 1.24z", fill: "#2790C3" },
		],
	},
	KakaoPay: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#FEE500" },
			{ d: "M14 20h3.5l-2 7h2.5l2-7H24v-3H14v3zm12-3v10h3V17h-3zm5 0l3.5 10H38l-3.5-10h-3.5z", fill: "#3C1E1E" },
		],
	},
	NaverPay: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#03C75A" },
			{ d: "M14 17l4.8 7.2V17h3v14h-3l-4.8-7.2V31h-3V17h3zm14 0h3v14h-3V17zm5 0h3l2.5 5.5L41 17h3v14h-3V22.5L38.5 28h-1l-2.5-5.5V31h-3V17z", fill: "white" },
		],
	},
	"Bank API": {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#607D8B" },
			{ d: "M24 12l-12 7v2h24v-2L24 12z", fill: "white" },
			{ d: "M14.5 22H16.5A0.5 0.5 0 0 1 17 22.5V31.5A0.5 0.5 0 0 1 16.5 32H14.5A0.5 0.5 0 0 1 14 31.5V22.5A0.5 0.5 0 0 1 14.5 22Z", fill: "white" },
			{ d: "M20 22H22A0.5 0.5 0 0 1 22.5 22.5V31.5A0.5 0.5 0 0 1 22 32H20A0.5 0.5 0 0 1 19.5 31.5V22.5A0.5 0.5 0 0 1 20 22Z", fill: "white" },
			{ d: "M26 22H28A0.5 0.5 0 0 1 28.5 22.5V31.5A0.5 0.5 0 0 1 28 32H26A0.5 0.5 0 0 1 25.5 31.5V22.5A0.5 0.5 0 0 1 26 22Z", fill: "white" },
			{ d: "M31.5 22H33.5A0.5 0.5 0 0 1 34 22.5V31.5A0.5 0.5 0 0 1 33.5 32H31.5A0.5 0.5 0 0 1 31 31.5V22.5A0.5 0.5 0 0 1 31.5 22Z", fill: "white" },
			{ d: "M12.5 33H35.5A0.5 0.5 0 0 1 36 33.5V35.5A0.5 0.5 0 0 1 35.5 36H12.5A0.5 0.5 0 0 1 12 35.5V33.5A0.5 0.5 0 0 1 12.5 33Z", fill: "white" },
		],
	},
	SmartStore: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#03C75A" },
			{ d: "M16 18h16l-2 14H18L16 18z", fill: "white" },
			{ d: "M20 18V15a4 4 0 018 0v3", stroke: "white", strokeWidth: 2.5 },
		],
	},
	Coupang: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#E31837" },
			{ d: "M32 19a8 8 0 00-16 0v1h3v-1a5 5 0 0110 0v10H16v3h16a3 3 0 003-3V19z", fill: "white" },
		],
	},
	Shopify: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#96BF48" },
			{ d: "M30 14s-.5-.1-.8 0c-.1 0-2 .6-2 .6s-1.3-1.3-1.5-1.5c-.2-.2-.5-.15-.7-.1l-1 .3s-.6-1.6-1.7-1.6c-.1 0-.2 0-.3.05C21.6 11.2 21 11 20.5 11c-3.3 0-4.9 4.1-5.4 6.2l-2.3.7c-.7.2-.72.24-.82.9-.07.5-1.98 15.2-1.98 15.2L27 37l9-2s-4.5-20.4-4.5-20.5-.5-.5-1.5-.5zm-4.3 1.5l-2.4.75c.4-1.7 1.3-3.1 2.7-3.4-.1.7-.2 1.6-.3 2.65zm-2.4-4.05c.2 0 .3.05.5.15-1.8.85-3.7 3.1-3.5 5.9l-2 .6C19 15.5 20.8 11.45 23.3 11.45zM22 24c.1 1.5 4 1.8 4.2 5.3.15 2.7-1.45 4.55-3.75 4.7-2.8.2-4.35-1.5-4.35-1.5l.6-2.5s1.55 1.15 2.8 1.05c.8-.05 1.1-.7 1.1-1.15-.1-2-3.3-1.85-3.5-5-.15-2.65 1.6-5.3 5.4-5.55 1.5-.1 2.2.3 2.2.3l-.9 3.3s-1-.45-2.1-.35c-1.6.1-1.65 1.1-1.65 1.4z", fill: "white" },
		],
	},
	Cafe24: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#145DA0" },
			{ d: "M18.5 27.5c0 1.8-1.4 3-3.2 3-2 0-3.3-1.5-3.3-3.8s1.3-3.8 3.3-3.8c1.6 0 2.8.9 3.1 2.3h-1.8c-.2-.6-.7-1-1.3-1-1 0-1.6.9-1.6 2.5s.6 2.5 1.6 2.5c.7 0 1.2-.5 1.4-1.1h1.8zM19.5 23.1h4.8v1.4h-2.8l-.3 1.8c.4-.3.9-.4 1.5-.4 1.6 0 2.7 1.1 2.7 2.7 0 1.7-1.2 2.9-2.9 2.9-1.5 0-2.6-.9-2.8-2.2h1.7c.2.5.6.8 1.1.8.7 0 1.2-.5 1.2-1.4 0-.8-.5-1.4-1.3-1.4-.5 0-1 .3-1.2.7h-1.5l.8-4.9zM30.5 28.8h-1v1.6h-1.7v-1.6h-3.3v-1.4l3-4.3h2v4.3h1v1.4zm-2.7-1.4v-2.5l-1.7 2.5h1.7z", fill: "white" },
		],
	},
	Amazon: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#232F3E" },
			{ d: "M13.2 23.2c.5-.2.9.1.9.5 0 .5-.1 1-.1 1.1 0 .3.2.4.4.3 0 0 .5-.2.8-.5.2-.2.4-.5.5-.9.2-.6.1-1.2.1-1.2-.2-.8-.8-1.2-1.7-1.2-.9 0-1.6.5-2 1.3-.4.7-.4 1.8.1 2.4.5.6 1.2.7 1.8.5.4-.2.6-.4.7-.4.2 0 .2.2.1.4-.2.3-.7.7-1.4.8-.9.2-1.7-.1-2.2-.8-.6-.8-.6-2.1-.1-3 .5-.9 1.4-1.5 2.5-1.5 1 0 1.8.5 2 1.4.2.8 0 1.7-.5 2.2-.4.4-.8.5-1 .5-.4 0-.5-.3-.3-.5l.4-.4zM18 21.2c0-.3.2-.5.5-.5h.3c.3 0 .4.1.5.4l1.2 3.5 1.2-3.5c.1-.3.2-.4.5-.4h.3c.3 0 .5.2.5.5v4.6c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3.2l-1 2.9c-.1.2-.2.3-.5.3s-.4-.1-.5-.3l-1-2.9v3.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4.6zM24 23.5c0-1.5 1-2.8 2.5-2.8s2.5 1.3 2.5 2.8-1 2.8-2.5 2.8-2.5-1.3-2.5-2.8zm4 0c0-1-.6-1.8-1.5-1.8s-1.5.8-1.5 1.8.6 1.8 1.5 1.8 1.5-.8 1.5-1.8zM30 21.2c0-.3.2-.5.5-.5h.1c.2 0 .4.1.5.3l2 3.2v-3c0-.3.2-.5.5-.5s.5.2.5.5v4.6c0 .3-.2.5-.5.5h-.1c-.2 0-.4-.1-.5-.3l-2-3.2v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4.6z", fill: "white" },
			{ d: "M16 28c0 0 4 3 8 3s8-3 8-3", stroke: "#FF9900", strokeWidth: 2, strokeLinecap: "round" },
			{ d: "M30 27l2 1.5-1.5 1.5", stroke: "#FF9900", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" },
		],
	},
	"11st": {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#FF0000" },
			{ d: "M20.5 18h-2l-2 2v1h2v8h2v-11zm7 0h-2l-2 2v1h2v8h2v-11z", fill: "white" },
		],
	},
	Sheets: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#0F9D58" },
			{ d: "M16 12H32A2 2 0 0 1 34 14V34A2 2 0 0 1 32 36H16A2 2 0 0 1 14 34V14A2 2 0 0 1 16 12Z", fill: "white" },
			{ d: "M17 17H23V20H17Z", fill: "#0F9D58" },
			{ d: "M25 17H31V20H25Z", fill: "#0F9D58" },
			{ d: "M17 22H23V25H17Z", fill: "#0F9D58" },
			{ d: "M25 22H31V25H25Z", fill: "#0F9D58" },
			{ d: "M17 27H23V30H17Z", fill: "#0F9D58" },
			{ d: "M25 27H31V30H25Z", fill: "#0F9D58" },
		],
	},
	Notion: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#000000" },
			{ d: "M16.5 13.5l9.5-.75c1.2-.1 1.5 0 2.25.55l3.1 2.15c.5.35.65.45.65.85v17.3c0 .7-.25 1.05-1.15 1.1l-11.1.65c-.65.04-1-.1-1.35-.5l-2.15-2.8c-.4-.5-.55-.9-.55-1.35v-16c0-.55.25-1.05 1-1.1z", fill: "white" },
			{ d: "M19 17v14.5l8.5-.5V18L24 15.5 19 17z", fill: "black", opacity: 0.08 },
			{ d: "M20.5 21L26 21", stroke: "black", strokeWidth: 1, opacity: 0.6 },
			{ d: "M20.5 24L26 24", stroke: "black", strokeWidth: 1, opacity: 0.6 },
			{ d: "M20.5 27L26 27", stroke: "black", strokeWidth: 1, opacity: 0.6 },
		],
	},
	Airtable: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#2D7FF9" },
			{ d: "M12 18l12-5 12 5v3l-12 5-12-5v-3z", fill: "white" },
			{ d: "M12 24l12 5 12-5v3l-12 5-12-5v-3z", fill: "white", opacity: 0.7 },
			{ d: "M12 30l12 5 12-5v3l-12 5-12-5v-3z", fill: "white", opacity: 0.4 },
		],
	},
	Dropbox: {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#0061FF" },
			{ d: "M24 14l-7 4.5 7 4.5 7-4.5L24 14z", fill: "white" },
			{ d: "M17 18.5l-4 2.5 7 4.5 4-2.5-7-4.5z", fill: "white", opacity: 0.85 },
			{ d: "M31 18.5l4 2.5-7 4.5-4-2.5 7-4.5z", fill: "white", opacity: 0.85 },
			{ d: "M13 21l7 4.5 4-2.5-7-4.5-4 2.5z", fill: "white", opacity: 0.7 },
			{ d: "M35 21l-7 4.5-4-2.5 7-4.5 4 2.5z", fill: "white", opacity: 0.7 },
			{ d: "M17 28l7 4.5 7-4.5v-2.5l-7 4.5-7-4.5V28z", fill: "white", opacity: 0.55 },
		],
	},
	"AWS S3": {
		viewBox: "0 0 48 48",
		elements: [
			{ d: "M24 0A24 24 0 1 1 24 48A24 24 0 1 1 24 0Z", fill: "#232F3E" },
			{ d: "M24 12l-8 3v18l8 3 8-3V15l-8-3z", fill: "#E25444" },
			{ d: "M24 12v24l8-3V15l-8-3z", fill: "#C23C2A" },
			{ d: "M22.2 26.5c0 .6.4 1 1 1.1.6.1 1.2-.2 1.2-.7 0-.4-.3-.7-.8-.8l-.7-.2c-.9-.2-1.4-.7-1.4-1.4 0-.9.7-1.5 1.7-1.5.9 0 1.6.5 1.7 1.2h-.9c-.1-.3-.4-.5-.8-.5s-.8.2-.8.6c0 .3.3.5.7.6l.7.2c1 .2 1.5.7 1.5 1.5 0 .9-.8 1.5-1.8 1.5-1 0-1.8-.6-1.8-1.5h.9zm4.3.5c.1.4.5.7 1 .7.7 0 1.1-.5 1.1-1.2 0-.7-.4-1.2-1.1-1.2-.5 0-.8.2-1 .6h-.8l.4-2.6h2.7v.7h-2l-.2 1.3c.3-.3.6-.4 1.1-.4.9 0 1.6.7 1.6 1.7 0 1-.7 1.8-1.8 1.8-.9 0-1.6-.5-1.7-1.3h.7z", fill: "white" },
		],
	},
};
